import { render, staticRenderFns } from "./WorksInstrumentationPanel.vue?vue&type=template&id=2a1c6327"
import script from "./WorksInstrumentationPanel.vue?vue&type=script&lang=js"
export * from "./WorksInstrumentationPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports